import { Checkbox, Divider, Modal, Typography } from "antd";
import React, { useEffect, useState } from "react";
import Address from "../Forms/Address";
import { useApiCall } from "../../services/api";
import { MdOutlineEdit } from "react-icons/md";
import { PlusOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { useGlobalModal } from "../../context/SuccessModalProvider";
import { deleteDefaultAddressMsg, roleIds } from "../../constant";
import PrimaryButton from "../Forms/PrimaryButton";
import { useAddressContext } from "../../pages/CheckOut";

const { Title } = Typography;

const AddressFormModal = ({
  isEditAddress,
  setIsEditAddress,
  handleFormSubmit,
  formData,
  setFormData,
}) => {
  return (
    <Modal
      className="form-css-5"
      open={isEditAddress}
      footer={null}
      onCancel={() => {
        setIsEditAddress((prev) => !prev);
        setFormData({});
      }}
    >
      <Address
        formData={formData}
        handleSubmit={handleFormSubmit}
        closeModal={() => setIsEditAddress(false)}
      />
    </Modal>
  );
};

const SelectAddressModal = ({
  isSelectAddress,
  setIsSelectAddress,
  addresses = [],
  setRefetch,
  addressType,
  customer_id,
  setDefaultAddress,
  onAddressSaved,
}) => {
  const [isEditAddressModal, setIsEditAddressModal] = React.useState(false);
  const [selectedAddress, setSelectedAddress] = React.useState({});
  const { postApi } = useApiCall();

  const { showPopup } = useGlobalModal();
  const {
    user_id,
    full_name,
    is_sales_person,
    is_sales_manager,
    is_admin,
    is_customer,
  } = useSelector((state) => state.auth);

  const handleCheckboxChange = async (e, address) => {
    e.stopPropagation();
    if (
      addressType === "delivery"
        ? address.is_default_delivery
        : address.is_default_billing && !e.target.checked
    ) {
      showPopup({
        title: null,
        content: (
          <span className="custom-modal-title">
            {deleteDefaultAddressMsg(addressType)}
          </span>
        ),
        onOk: () => console.log("Confirmed!"),
        className: "custom-success-modal",
      });
      return;
    }
    const apiRoute =
      addressType === "delivery"
        ? "sales/address/set-default-delivery"
        : "sales/address/set-default-billing";

    const customerApi =
      addressType === "delivery"
        ? "address/set-default-delivery"
        : "address/set-default-billing";

    const body = {};
    if (addressType === "delivery") {
      body.is_default_delivery = e.target.checked ? 1 : 0;
    } else {
      body.is_default_billing = e.target.checked ? 1 : 0;
    }

    try {
      const response = await postApi(is_customer ? customerApi : apiRoute, {
        address_id: address.address_id,
        customer_id: customer_id,
        updated_by: full_name,
        updated_by_id: user_id,
        ...body,
      });
      if (response?.status) {
        setRefetch((prev) => !prev);
      }
    } catch (error) {
      console.log("Error", error);
    }
  };

  const handleFormSubmit = (data) => {
    const mergedAddress = { ...selectedAddress, ...data };
    setSelectedAddress(mergedAddress);
    setIsEditAddressModal(false);
    setRefetch((prev) => !prev);

    if (onAddressSaved) {
      onAddressSaved(mergedAddress, addressType);
      return;
    }
  };

  const handleEditModalOpen = (e, address, type) => {
    e.stopPropagation();
    setSelectedAddress({ ...address, type, customer_id });
    setIsEditAddressModal(true);
  };

  const handleSelectDefault = (address) => {
    setDefaultAddress((prev) => ({
      ...prev,
      [addressType + "Address"]: address,
    }));
    setIsSelectAddress(false);
  };

  return (
    <>
      <Modal
        className="flex flex-col items-center justify-center form-css"
        wrapClassName="custom-modal-wrap"
        open={isSelectAddress}
        footer={null}
        onCancel={() => setIsSelectAddress(false)}
      >
        <div className="w-full">
          <Title className="input-css font-abhaya" level={2}>
            Select {addressType} address
          </Title>

          {addresses.length > 0 ? (
            addresses.map((address) => (
              <div
                key={address.address_id}
                className={`border rounded-[32px] p-4 mb-4 flex flex-col hover:bg-gray-100 hover:shadow-lg transition-all duration-200 cursor-pointer min-w-[300px]
                // defaultAddress?.[addressType + "Address"]?.address_id === address.address_id
                //   ? "bg-red-100"
                //   : ""
              `}
                onClick={() => handleSelectDefault(address)}
              >
                <div className="w-full flex flex-wrap gap-2 justify-between items-center mb-2">
                  <div className="flex items-center gap-3 w-full">
                    <div className="w-[50px] h-[50px] shrink-0 bg-[#A334341A] rounded-full flex items-center justify-center">
                      <img
                        src="/assets/icons/address.png"
                        alt="Address"
                        className="w-[30px] h-[30px] object-contain"
                      />
                    </div>

                    <div className="flex flex-col flex-1 min-w-0">
                      <h2
                        className={`truncate max-w-full overflow-hidden whitespace-nowrap font-semibold`}
                        title={address.title}
                      >
                        {address.title}
                      </h2>
                    </div>

                    <div className="shrink-0">
                      {is_sales_manager || is_admin || is_customer ? (
                        <Checkbox
                          checked={
                            addressType === "delivery"
                              ? address.is_default_delivery
                              : address.is_default_billing
                          }
                          onClick={(e) => e.stopPropagation()}
                          onChange={(e) => handleCheckboxChange(e, address)}
                          className="custom-checkbox text-black"
                        >
                          Mark as default
                        </Checkbox>
                      ) : (address?.is_default_billing === 1 &&
                          addressType === "billing") ||
                        (address?.is_default_delivery === 1 &&
                          addressType === "delivery") ? (
                        <p className="text-sm font-medium text-gray-600 whitespace-nowrap">
                          Default
                        </p>
                      ) : null}
                    </div>
                  </div>
                </div>
                <span>
                  {[
                    address?.address_line_1,
                    address?.address_line_2,
                    address?.city,
                    address?.state,
                    address?.postal_code,
                    address?.country,
                  ]
                    .filter(Boolean)
                    .join(", ")}
                </span>

                {(is_sales_manager || is_admin || is_customer) && (
                  <>
                    <Divider className="border-gray-300 self-stretch m-0 my-2" />
                    <button
                      onClick={(e) => handleEditModalOpen(e, address, "edit")}
                      className="flex items-center gap-2 mx-auto"
                    >
                      <div className="w-[35px] h-[35px] bg-[#A33434] rounded-full flex items-center justify-center">
                        <MdOutlineEdit className="text-white" />
                      </div>
                      <span>Edit</span>
                    </button>
                  </>
                )}
              </div>
            ))
          ) : (
            <>No addresses found</>
          )}

          {(is_sales_manager || is_admin || is_customer) && (
            <div className="flex mt-4 w-full text-center max-w-md mx-auto justify-center">
              <PrimaryButton
                text="Add New"
                onClick={(e) => handleEditModalOpen(e, {}, "add")}
                icon={<PlusOutlined className="w-4 h-4 text-white" />}
                iconOnleft
                className="me-[30px]"
              />
            </div>
          )}
        </div>
      </Modal>

      <AddressFormModal
        isEditAddress={isEditAddressModal}
        setIsEditAddress={setIsEditAddressModal}
        handleFormSubmit={handleFormSubmit}
        formData={selectedAddress}
        setFormData={setSelectedAddress}
      />
    </>
  );
};

const ChangeAddress = ({
  isMainModalOpen,
  setIsMainModalOpen,
  addresses = [],
  setAddresses,
  customer_id,
  defaultAddress,
  setDefaultAddress,
  addressType = "delivery",
  onAddressSaved,
}) => {
  const [refetch, setRefetch] = useState(false);
  const [tempAddresses, setTempAddresses] = useState(addresses);
  const { is_customer } = useSelector((state) => state.auth);
  const customerId = useSelector((state) => state.auth?.customer_id);
  const { postApi } = useApiCall();

  const fetchAddresses = async (customer_id) => {
    if (!customer_id) return;
    try {
      const response = await postApi(
        is_customer ? "address" : "sales/address/list",
        {
          customer_id: is_customer ? customerId : customer_id,
        },
      );
      setAddresses && setAddresses(response.data || []);
      setTempAddresses(response.data || []);
    } catch (error) {
      console.error("Error fetching addresses:", error);
    }
  };

  useEffect(() => {
    fetchAddresses(customer_id);
  }, [customer_id, refetch]);

  return (
    <>
      <SelectAddressModal
        isSelectAddress={isMainModalOpen}
        addresses={tempAddresses}
        setIsSelectAddress={setIsMainModalOpen}
        setRefetch={setRefetch}
        addressType={addressType}
        customer_id={customer_id}
        defaultAddress={defaultAddress}
        setDefaultAddress={setDefaultAddress}
        onAddressSaved={onAddressSaved}
      />
    </>
  );
};

export default ChangeAddress;
